module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('div', [_c('div', {
    staticClass: "is-inline-block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('callTasks.byCampaign')) + " " + _vm._s(_vm.campaign.name))]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('callTasks.phoneNumber')) + " " + _vm._s(_vm.callTask.phone))])]), _vm._v(" "), (_vm.scenarioTestAudio) ? _c('div', {
    staticClass: "is-inline-block resultAudio"
  }, [_c('audio', [(_vm.scenarioTestAudio) ? _c('source', {
    attrs: {
      "src": _vm.scenarioTestAudio
    }
  }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.$t('scenarios.konstruktor.canvas.answer.initAudio.Your_browser_does_not_support_html5_audio_Try_chrome')) + "\n          ")]), _vm._v(" "), (_vm.scenarioTestAudio) ? _c('audio-player', {
    attrs: {
      "file": _vm.scenarioTestAudio
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('p', {
    staticClass: "control"
  }, [_vm._v("\n          " + _vm._s(_vm.$t('callTasks.state')) + "  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskState),
      expression: "callTaskState"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskState)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskState = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('collapse', {
    attrs: {
      "accordion": ""
    }
  }, [_c('collapse-item', {
    attrs: {
      "title": "Результаты",
      "selected": ""
    }
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.parameter')) + " ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.results), function(res) {
    return _c('tr', [_c('td', [_vm._v("\n                  " + _vm._s(res[0]) + "\n                ")]), _vm._v(" "), (res[0] == 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(_vm.getDateTime(res[1])) + "\n                ")]) : _vm._e(), _vm._v(" "), (res[0] != 'time') ? _c('td', [_vm._v("\n                  " + _vm._s(res[1]) + "\n                ")]) : _vm._e()])
  }), 0)])]), _vm._v(" "), _c('collapse-item', {
    attrs: {
      "title": _vm.$t('common.information')
    }
  }, [_c('p', {
    staticClass: "info"
  }, [_vm._v("\n              Тег  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.tag),
      expression: "callTask.tag"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "tag", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              failComment  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.failComment),
      expression: "callTask.failComment"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.failComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "failComment", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              calledTimestamp  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.calledTimestamp),
      expression: "callTask.calledTimestamp"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.calledTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "calledTimestamp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              talkMillis  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.talkMillis),
      expression: "callTask.talkMillis"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.talkMillis)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "talkMillis", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              nextAttemptTimestamp  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.nextAttemptTimestamp),
      expression: "callTask.nextAttemptTimestamp"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.nextAttemptTimestamp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "nextAttemptTimestamp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              parameters  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskParameters),
      expression: "callTaskParameters"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskParameters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskParameters = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              reportParameters  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTaskReportParameters),
      expression: "callTaskReportParameters"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTaskReportParameters)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.callTaskReportParameters = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "info"
  }, [_vm._v("\n              created  "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.callTask.created),
      expression: "callTask.created"
    }],
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.callTask.created)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.callTask, "created", $event.target.value)
      }
    }
  })])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-light",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.close')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ce8085e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/calltasks/TestCallTasksResult.vue
// module id = 322
// module chunks = 42